import { render, staticRenderFns } from "./Culture.vue?vue&type=template&id=1013c3dc&scoped=true"
import script from "./Culture.vue?vue&type=script&lang=ts"
export * from "./Culture.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1013c3dc",
  null
  
)

export default component.exports